import { motion, useReducedMotion } from "framer-motion";
import Reveal from "../../motion/Reveal";

const services = [
  ["Medicine", "Fever, blood pressure, diabetes follow-up, acidity, weakness, and the illnesses that fill a neighbourhood OPD."],
  ["Women & maternity", "Antenatal visits, period problems, and gynaecology. Come early in pregnancy rather than waiting for the ninth month."],
  ["Children", "Fever, cough, loose motions, poor feeding, and growth questions. Bring the vaccination card."],
  ["Orthopaedics", "Knee pain, back pain, sprains, and fractures that need an X-ray and a clinician, not a neighbour’s advice."],
  ["Laparoscopic surgery", "Selected abdominal operations done through small cuts, when the surgeon advises that route."],
  ["Diabetes", "Sugar checks, foot and eye risk, diet questions, and medicine review. Do not change doses from a blog."],
  ["Emergency help", "For chest pain, breathlessness, heavy bleeding, fainting, or a seizure, call the hospital and also use local emergency services."],
  ["Laboratory", "Blood tests and sample collection. Reports are issued through NABL / ISO certified partner laboratories. Home collection is available."],
];

const steps = [
  ["Call or walk in", "OPD is 9:00 AM to 5:00 PM, all week. Phone is the way to ask who is sitting that day."],
  ["Register at the desk", "Carry an ID, old papers, and a list of medicines. There is no website form to fill."],
  ["See the clinician", "Explain the problem in your own words. Ask what the medicine is for before you leave."],
  ["Tests, only if asked", "The lab collects samples here or at home. Do not stack tests because a relative suggested them."],
];

const Specialties = () => {
  const reduce = useReducedMotion();

  return (
    <section className="section section-tight" id="services">
      <div className="wrap">
        <Reveal className="section-head">
          <p className="kicker">
            <span>02</span> Services
          </p>
          <h2>What you can come in for.</h2>
          <p>
            These are the services the hospital actually offers. If you are unsure
            whether your problem fits, call. A receptionist is more useful than a guess.
          </p>
        </Reveal>
        <ul className="service-list">
          {services.map(([title, copy], index) => (
            <motion.li
              key={title}
              initial={reduce ? false : { opacity: 0, y: 16 }}
              whileInView={reduce ? undefined : { opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "0px 0px -8% 0px" }}
              transition={{ duration: 0.55, delay: reduce ? 0 : (index % 4) * 0.05, ease: [0.22, 1, 0.36, 1] }}
              whileHover={reduce ? undefined : { x: 6 }}
            >
              <span className="idx">{String(index + 1).padStart(2, "0")}</span>
              <h3>{title}</h3>
              <p>{copy}</p>
            </motion.li>
          ))}
        </ul>
        <ol className="steps">
          {steps.map(([title, copy]) => (
            <li key={title}>
              <h3>{title}</h3>
              <p>{copy}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Specialties;
